/**
 * GuestCtaBanner — sits below the dashboard greeting for guest users. Tap
 * opens the GuestSignupContent drawer. Mirrors RN Dashboard's renderGuestCTA.
 */
import React from 'react';
import './GuestCtaBanner.css';

interface Props {
  text: string;
  ctaText: string;
  onClick: () => void;
}

const GuestCtaBanner: React.FC<Props> = ({ text, ctaText, onClick }) => (
  <button
    type="button"
    className="wg-guest-cta-banner"
    onClick={onClick}
    aria-label={ctaText}
  >
    <span className="wg-guest-cta-banner__text">{text}</span>
    <span className="wg-guest-cta-banner__chev" aria-hidden>
      ›
    </span>
  </button>
);

export default GuestCtaBanner;
